/**
 * Extract the backend's machine-readable error code (e.g.
 * `audience.push_rfp.unit_products_required`) from a rejected API error, so a
 * caller can branch on a specific failure instead of matching message text.
 *
 * `backend-request` rejects with the unwrapped `{ code, message, context }`
 * envelope when the backend sends one, and with the raw `{ status, data }` from
 * the axios interceptor otherwise — neither carries an axios `response`, so both
 * shapes are read here. Returns `undefined` when the error has no code.
 */
export const getApiErrorCode = (err: unknown): string | undefined => {
  const unwrapped = err as
    | { code?: unknown; data?: { error?: { code?: unknown } } | null }
    | null
    | undefined;
  const code = unwrapped?.code ?? unwrapped?.data?.error?.code;
  return typeof code === 'string' ? code : undefined;
};
